export default "__VITE_ASSET__5a3d890a__"